import Controller from '@ember/controller';
import { action } from '@ember/object';

import type { Metric } from 'webapp/models-custom';

export default class MetricLibraryIndexController extends Controller {
	@action
	sendSourceChange(sourceKey: string): void {
		// to route:metric-library
		this.send('changeSource', sourceKey);
	}

	@action
	sendAddMetricsToBoard(selectedMetrics: Metric[]): void {
		return this.send('addMetricsToBoard', selectedMetrics);
	}
}
